export type {
    AxiosRequestConfig as RequestConfig,
    AxiosResponse as ResponseConfig,
    AxiosError as ResponseErrorConfig,
} from 'axios'
import axios from 'axios'
import { TOKEN_ERROR } from '../../constants/error.constants'
import { OIDC_AUTHORITY, OIDC_CLIENT_ID } from '../endpoints.constants'

export const getToken = () => {
    const auth = sessionStorage.getItem(`oidc.user:${OIDC_AUTHORITY}:${OIDC_CLIENT_ID}`)

    // get token for web view pages
    let token: string | null = new URL(window.location.toString()).searchParams.get('accessToken')

    if (!auth) {
        return token
    }

    try {
        const data = JSON.parse(auth) as { access_token: string }

        token = data?.access_token ?? null
    } catch (error) {
        console.log(error)
    }

    return token
}

export const createClient = (baseURL: string, withCredentials: boolean) => {
    const inst = axios.create({
        baseURL,
        'Content-Type': 'application/json',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        withCredentials,

        // timeout: 2000,
    })

    inst.interceptors.request.use(
        (config) => {
            const token = getToken()
            if (token) {
                config.headers.Authorization = `Bearer ${token}`
            }
            return config
        },
        (error) => {
            return Promise.reject(error)
        },
    )

    inst.interceptors.response.use(undefined, (error) => {
        const error_code = error?.response?.data?.detail?.error_code || null
        const statusCode = error?.response?.status
        if (error_code === TOKEN_ERROR || statusCode === 401) {
            window.location.href = `/login?rpg=${window.location.pathname}`
        }
        return Promise.reject(error)
    })
    return inst
}
